import { z } from 'zod';

/** Per–assessment-objective result stored under evaluation_payload.objective_results[ao_id] */
export const ScfObjectiveResultEnum = z.enum([
    'met',
    'not_met',
    'not_applicable',
    'compensating_control'
]);

export const ScfControlEvaluationEvidenceSchema = z.object({
    id: z.string().optional(),
    fileName: z.string(),
    storedName: z.string().optional(),
    filePath: z.string().optional(),
    fileUrl: z.string().optional(),
    mimeType: z.string().optional(),
    size: z.number().optional(),
    uploadedBy: z.string().optional(),
    uploadedAt: z.string().optional()
});

export const ScfControlEvaluationNoteSchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    userId: z.string().optional().nullable(),
    user: z.string().optional(),
    text: z.string(),
    date: z.string().optional()
});

/**
 * Tenant-specific overlay for an SCF control (stored in tenant_control_evaluations.evaluation_payload).
 * Extra keys are allowed for forward-compatible extensions.
 */
export const ScfControlEvaluationPayloadSchema = z
    .object({
        process_maturity_current: z.number().int().min(0).max(5).optional(),
        process_maturity_target: z.number().int().min(0).max(5).optional(),
        control_implementation_maturity: z.number().int().min(0).max(5).optional(),
        objective_results: z.record(z.string(), ScfObjectiveResultEnum).optional(),
        objective_comments: z.record(z.string(), z.string()).optional(),
        objective_compensating_controls: z.record(z.string(), z.array(z.string())).optional(),
        comment: z.string().optional(),
        evidences: z.array(ScfControlEvaluationEvidenceSchema).optional(),
        notes: z.array(ScfControlEvaluationNoteSchema).optional()
    })
    .passthrough();

export const CreateControlEvaluationVersionBodySchema = z.object({
    evaluation_payload: ScfControlEvaluationPayloadSchema.optional().default({}),
    change_reason: z.string().max(2000).optional().nullable()
});
